<div class="relative flex h-full min-w-0 flex-col justify-end">
  <p-chart
    type="doughnut"
    [data]="data"
    [options]="options"
    [plugins]="plugins"
  />
</div>
